import { useContext, useEffect } from "react";

import MapContext from "../map/MapContext";

import olMap from "ol/Map";
import { ScaleLine } from "ol/control";

/**
 * Component to register the OL ScaleBar control on the Map
 * using the MapContext.
 * @component
 * @example
 * <Map center={center} zoom={zoom} projection={Epsg27700}>
 *   ...
 *   <Controls>
 *     <ScaleBar />
 *   </Controls>
 * </Map>
 */
const ScaleBar = () => {
  const map = useContext(MapContext) as olMap;

  useEffect(() => {
    if (!map) return () => {};

    const control = new ScaleLine({
      units: "metric",
      bar: true,
      steps: 4,
      text: true,
      minWidth: 140,
    });
    map.addControl(control);

    return () => {
      if (!map) return;
      map.removeControl(control);
    };
  }, [map]);

  return null;
};

export default ScaleBar;
